import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import CodeMirrorComponent from 'react-codemirror-component';
import 'codemirror/addon/fold/xml-fold';
import 'codemirror/addon/edit/matchtags';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/edit/closetag';
import 'codemirror/mode/xml/xml';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/mode/markdown/markdown';

import 'codemirror/lib/codemirror.css';
import { changeContent } from '../../../actions/post';
import MarkdownHelper from '../../../lib/MarkdownHelper';
import CategorySelect from '../CategorySelect';
import SimpleEditorToolbar from '../SimpleEditorToolbar';
import PostTitle from '../PostTitle';
import CodeMirrorTistory from '../../../lib/codemirror/CodeMirrorTistory';


@connect(state => ({
  post: state.post.newPost,
  blog: state.blog,
}), dispatch => ({
  handleChangeContent: content => {
    dispatch(changeContent(content));
  },
}))
class MarkdownEditor extends Component {
  constructor (props) {
    super(props);

    this.codemirrorComponent = React.createRef();
  }

  componentDidMount () {
    window.activeEditor = this.codemirrorComponent.current.getCodeMirror();
  }

  shouldComponentUpdate (nextProps, nextState, nextContext) {
    if (Math.abs(this.props.post.content.length - nextProps.post.content.length) > 100) {
      this.codemirrorComponent.current.getCodeMirror().refresh();
    }
    return false;
  }

  @autobind
  handleChangeContent (content) {
    const { handleChangeContent } = this.props;
    handleChangeContent(MarkdownHelper.markdownToHtml(content));
  }

  @autobind
  handleAttachImage (data) {
    CodeMirrorTistory.insertImage(this.codemirrorComponent.current.getCodeMirror(), data);
  }

  @autobind
  handleAttachFile (data) {
    CodeMirrorTistory.insertFile(this.codemirrorComponent.current.getCodeMirror(), data);
  }

  render () {
    const { post } = this.props;

    return (
      <div className={'markdown-editor'}>
        <CategorySelect />
        <PostTitle/>

        <SimpleEditorToolbar
          onAttachImage={this.handleAttachImage}
          onAttachFile={this.handleAttachFile}
        />

        <div className={'mce-edit-area'}>
          <CodeMirrorComponent
            ref={this.codemirrorComponent}
            autoFocus={true}
            value={MarkdownHelper.htmlToMarkdown(post.content)}
            onChange={this.handleChangeContent}
            options={{
              lineWrapping: true,
              mode: 'markdown',
              theme: 'tistory-markdown',
              htmlMode: true,
              matchClosing: true,
              viewportMargin: 50,
            }}
          />
        </div>

      </div>
    );
  }
}

export default MarkdownEditor;
